module.exports = __webpack_public_path__ + "img/researchBanner.d5ebb115.png";